export const FIND_DOCUMENTS_FAILURE = 'FIND_DOCUMENTS_FAILURE';

export const findDocumentsFailure = ({ error, request }) => ({
    type: FIND_DOCUMENTS_FAILURE,
    payload: error,
    error: true,
    meta: {
        request
    }
});